const HelpAction = (props) => {


    return ( 
        <div className="helpaction">
            <table className="menu">
                <tbody>
                    <tr className="help">
                        <td className="bgrd"></td>
                        <td className="bgrd" style={{paddingLeft: '30px'}}>
                            <a className="bgrd" href={props.helpPt}>
                                <button style={{padding: '1px 15px'}} type="button"> Ajuda </button>
                            </a>
                        </td>
                        <td className="bgrd">
                            <a className="bgrd" href={props.helpUk}>
                                <button type="button"> Help </button>
                            </a>
                        </td>
                    </tr>
                    <tr className="action">
                        <td className="bgrd" style={{color: 'fuchsia', backgroundColor: 'rgba(205,209,220,0.2)'}}>
                            {props.ling === 'pt' && <h3 className="bgrd">{props.titPt} </h3>}
                            {props.ling === 'uk' && <h3 className="bgrd">{props.titUk} </h3>}
                        </td>
                        <td className="bgrd" style={{paddingLeft: '30px'}}>
                            {props.ling === 'pt' && <button style={{padding: '1px 12px'}} type="button" onClick={(e) => props.query(e)}> Colorir </button>}
                            {props.ling === 'uk' && <button style={{padding: '1px 7px 1px 8px'}} type="button" onClick={(e) => props.query(e)}> To color </button>}
                        </td>
                        <td className="bgrd" >
                            <button type="button" onClick={() => props.download(props.csv, props.ling)}> CSV </button>
                        </td>
                    </tr>
                </tbody>
            </table>                     
        </div>
    );
}

export default HelpAction;